import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export interface ClientLogos {
  id: string;
  name: string;
  primaryLogoUrl: string | null;
  clientLogoUrl: string | null;
}

/**
 * Fetches the first client record's logos.
 * Single-tenant: returns the one client's logos for use throughout the app.
 */
export function useClientLogos() {
  return useQuery({
    queryKey: ['client-logos'],
    queryFn: async (): Promise<ClientLogos | null> => {
      const { data, error } = await supabase
        .from('clients' as any)
        .select('id, name, primary_logo_url, client_logo_url')
        .limit(1)
        .maybeSingle();

      if (error) {
        console.error('Failed to fetch client logos:', error);
        return null;
      }
      if (!data) return null;

      return {
        id: (data as any).id,
        name: (data as any).name,
        primaryLogoUrl: (data as any).primary_logo_url,
        clientLogoUrl: (data as any).client_logo_url,
      };
    },
    staleTime: 5 * 60 * 1000, // 5 min cache
  });
}
